module.exports = __webpack_public_path__ + "img/demo4.c0f1fa73.png";